import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: "100%",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
  },
  container: {
    height: "100%",
    [theme.breakpoints.up("sm")]: {
      height: "100%",
      alignItems: "center",
    },
  },
  userButton: {
    width: "100%",
    height: 44,
    borderRadius: 0,
    marginBottom: 15,
    marginTop: 15,
    [theme.breakpoints.up("sm")]: {
      width: 44,
      height: 40,
      borderRadius: 0,
      justifyContent: "center",
      alignItems: "center",
    },
  },
  saveButton: {
    width: "40%",
    height: 44,
    borderRadius: 0,
    marginBottom: 15,
    marginTop: 15,
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      display: "flex",
      borderColor: "#fff",
      backgroundColor: "#658D1B",
      color: "#fff",
      borderWidth: 3,
      borderRadius: 0,
      margin: 7,
      padding: 20,
    },
  },
  edit: {
    marginTop: 10,
    marginLeft: 10,
    [theme.breakpoints.up("md")]: {
      display: "flex",
      alignItems: "flex-end",
      marginBottom: 18,
    },
  },
  firstRow: {
    flexDirection: "row",
    display: "flex",
    justifyContent: "stretch",

    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
      alignContent: "flex-start",
      display: "flex",
      justifyContent: "stretch",
    },
  },
  address: {
    flexDirection: "row",
    display: "flex",
    borderColor: "#658D1B",
    borderWidth: 3,
    borderRadius: 0,
    margin: 7,
  },
  label: {
    flexDirection: "row",
    display: "flex",
    borderColor: "#4f8c0d",
    borderWidth: 3,
    borderRadius: 0,
    margin: 7,
  },
  error: {
    color: "red",
    marginLeft: 15,
    fontSize: 13,
    paddingTop: 2,
    marginTop: 0,
  },
  button: {
    background: "#4f8c0d",
    border: 0,
    borderRadius: 1,
    color: "white",
    marginLeft: 10,
    marginRight: 10,
    alignItems: "center",
    justifyContent: "center",
    height: 40,
    width: "90%",
    [theme.breakpoints.up("md")]: {
      width: 200,
    },
  },
  combobox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginRight: 50,
  },
  radio: {
    marginLeft: 75,
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.up("sm")]: {
      marginLeft: 0,
      alignItems: "center",
    },
  },
  secondRow: {
    height: "2rem",
    marginTop: 10,

    marginBottom: 10,
    [theme.breakpoints.up("md")]: {
      height: "2rem",
    },
  },
  thirdRow: {
    height: "100%",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    padding: 15,
  },
  forthRow: {
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      height: "100%",
      justifyContent: "flex-start",
      alignItems: "flex-start",
    },
  },
  comboGrid: {
    flexDirection: "column",
    display: "flex",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
      alignItems: "center",
    },
  },
  cnpj: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    marginTop: 10,
    [theme.breakpoints.up("md")]: {
      marginTop: 0,
      alignItems: "center",
      justifyContent: "flex-start",
      flexDirection: "row",
      display: "flex",
    },
  },
  cnpjField: {
    [`& fieldset`]: {
      borderRadius: 0,
    },
    marginRight: 0,
    [theme.breakpoints.up("md")]: {
      marginRight: 0,
    },
  },
  notificationRight: {
    left: "auto",
    right: 0,
    maxHeight: "92%",
  },
  checkedB: {
    alignItems: "flex-start",
    justifyContent: "flex-start",
  },
}));

export default useStyles;
